import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useToast } from "../hooks/useToast";

export default function LoginPage() {
  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const { login }  = useAuth();
  const toast      = useToast();
  const navigate   = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token.trim()) return;
    // Verify the token by hitting a protected endpoint
    try {
      const res = await fetch("/api/storefronts?admin=1", {
        headers: { Authorization: `Bearer ${token.trim()}` },
      });
      if (res.status === 401) { setError("Invalid admin token."); return; }
      if (!res.ok) throw new Error("Server error");
      login(token.trim());
      toast("Logged in as admin", "success");
      navigate("/admin");
    } catch {
      setError("Could not verify token. Check that the server is running.");
    }
  };

  return (
    <div className="container main-area" style={{maxWidth:400,margin:"80px auto"}}>
      <div className="card card-padded">
        <h1 style={{fontFamily:"var(--ff-d)",fontSize:"1.6rem",marginBottom:4}}>Admin Login</h1>
        <p style={{fontSize:".85rem",color:"var(--muted)",marginBottom:24}}>
          Enter your ADMIN_SECRET token to manage storefronts.
        </p>
        <form onSubmit={handleSubmit} style={{display:"flex",flexDirection:"column",gap:16}}>
          <div className="form-group">
            <label className="form-label">Admin Token</label>
            <input
              className="form-input" type="password" autoComplete="current-password"
              value={token} onChange={e => setToken(e.target.value)}
              placeholder="Your ADMIN_SECRET value" required />
          </div>
          {error && <p className="form-error">⚠ {error}</p>}
          <button type="submit" className="btn btn-primary">Log In</button>
        </form>
      </div>
    </div>
  );
}
